import { Icon, message, Button, Form, Row, Col, Checkbox, AutoComplete } from 'antd';
import React from 'react';
import { invoiceImport, invoiceInput } from 'src/api';
import BaseImport, { IProps } from './BaseImport';
import debounce from 'lodash/debounce';
const FormItem = Form.Item;
const Option = AutoComplete.Option;
const css = require('../index.scss');
class Component extends BaseImport<IProps, any> {
    public timer: number = 0;
    constructor(props: IProps) {
        super(props);
        this.state = {
            callback: null,
            keyPrefix: null,
            token: null,
            uploadUrl: null,
            loop: null,
            fileList: null,
            url: this.props.url && this.props.url.scanerurl,
            message: null,
            params: this.props.url && this.props.url.scanerParams,
            groupNumber: null,
            showFive: this.props.url.show || false,
            list: [],
            draftFlag: 1,
            showdeduction: this.props.url.deduction || false,
            inputType: this.props.url.ocrinputType,
            workStatus: null,
            successCount: 0,
            totalCount: 0,
            failCount: 0,
            queryOcr: this.props.url.queryOcr || false,
        };
        this.fetchGroup = debounce(this.fetchGroup, 800);

    }
    ondraftChange = (e) => {
        if (e.target.checked) {
            this.setState({
                draftFlag: 1
            });
        } else {
            this.setState({
                draftFlag: 0
            });
        }
    }
    getToken = () => {
        this.setState({
            message: ''
        });
        const { url, draftFlag, inputType } = this.state;
        const groupNumber = this.props.form.getFieldValue('groupNumber');
        let data = {
            ...this.state.params,
            groupNumber,
            url,
            draftFlag,
            inputType
        };
        if (typeof data.url === 'function') {
            data.url(data);
        } else {
            invoiceImport.ocrImport(this, data).then((response: any) => {
                const err = response.err;
                const res = response.res;
                if (err) {
                    message.error(err.body.message);
                    return;
                }
                if (res) {
                    if (res.ok) {
                        this.setState({
                            message: res.body.message
                        });
                        if (this.state.queryOcr) {
                            this.timer = window.setInterval(this.queryMachine, 5000);
                        }
                    } else {
                        this.setState({
                            message: res.message
                        });
                    }
                }
            });
        }
    }
    queryMachine = () => {
        invoiceImport.queryocr(this, null).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (!err) {
                if (res.ok) {
                    this.setState({
                        totalCount: res.body.data.totalCount,
                        successCount: res.body.data.successCount,
                        workStatus: res.body.data.workStatus,
                        failCount: res.body.data.failCount
                    });
                    if (res.body.data.workStatus === "SUCCESS" || res.body.data.workStatus === "FAIL") {
                        window.clearInterval(this.timer);
                        this.updateBatch();
                    }
                }
            }

        });
    }
    updateBatch=()=>{
        
    }
    componentWillUnmount() {
        window.clearInterval(this.timer);
    }
    onAddGroup = () => {
        invoiceInput.CreatGroup(this, {}).then((response: any) => {
            const err2 = response.er;
            const res = response.res;
            if (err2) {
                return null;
            } else {
                if (res) {
                    message.success('操作成功');
                    this.props.form.setFieldsValue({ groupNumber: res });
                }
            }
        });
    }
    onGroupName = (e) => {
        this.setState({
            groupNumber: e.target.value
        });
    }
    fetchGroup = (value) => {
        const groupNumber = value;
        if (groupNumber) {
            invoiceInput.GetGroupList(this, { groupNumber }).then((response: any) => {
                const err = response.er;
                const res = response.res;
                if (err) {
                    return null;
                } else {
                    if (res) {
                        this.setState({
                            list: res
                        });
                    }
                }
            });
        }
    }
    render() {
        let formItemLayout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
        };
        const { getFieldDecorator } = this.props.form;
        const { workStatus, successCount, totalCount, failCount, queryOcr } = this.state;
        let status = "处理中";
        if (workStatus === "SUCCESS" || workStatus === "FAIL") {
            status = '处理结束';
        }
        const options = this.state.list.map(d => <Option key={d.groupNumber}>{d.groupNumber}</Option>);
        return (
            <div>
                <div>{this.state.message}</div>
                <Button onClick={this.getToken}>
                    <Icon type="upload" />扫描仪连接
                </Button>
                {
                    this.state.showFive &&
                    <Form >
                        <Row style={{ marginTop: 20 }}>
                            <Col span={21} >
                                <FormItem {...formItemLayout} label="指定到发票组">
                                    {getFieldDecorator('groupNumber', {
                                        rules: [{ message: '请输入编号(最大长度36位)', max: 36 }]
                                    })(
                                        <AutoComplete
                                            onSearch={this.fetchGroup}
                                        >
                                            {options}
                                        </AutoComplete>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={2} offset={1}>
                                <span style={{ lineHeight: '39px' }} className="hand" onClick={this.onAddGroup}><Icon type="plus" /></span>
                            </Col>
                        </Row>

                    </Form>
                }
                {
                    queryOcr &&
                    <span>扫描仪:{status} <span> 总共:{totalCount}张,成功:{successCount}张,失败:{failCount}张</span></span>
                }
                {
                    this.state.showdeduction &&
                    <Row>
                        <FormItem {...formItemLayout} >
                            {getFieldDecorator('draftFlag', {
                                valuePropName: 'checked',
                                initialValue: !!this.state.draftFlag
                            })(
                                <Checkbox onChange={this.ondraftChange} >录入时勾选发票</Checkbox>
                            )}
                        </FormItem>
                    </Row>
                }

            </div>
        );
    }
}
const ManualImport = Form.create()(Component);
export default ManualImport;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/InvoiceImport/InvoiceTab/OcrScanerImport.tsx